import { useQuery } from '@apollo/client';

import { SearchAlertOrigin } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import {
  GetSearchAlertsDocument,
  GetSearchAlertsQuery,
} from '@xing-com/crate-jobs-graphql';

import type { UseSearchAlertsValue } from './types';

type UseSearchAlertsProps = {
  origin?: SearchAlertOrigin;
};

export const useSearchAlerts = ({
  origin,
}: UseSearchAlertsProps = {}): UseSearchAlertsValue => {
  const { isLoggedIn } = useLoginState();
  const queryResult = useQuery<
    GetSearchAlertsQuery,
    { origin?: SearchAlertOrigin }
  >(GetSearchAlertsDocument, {
    skip: !isLoggedIn,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    variables: {
      origin,
    },
  });

  return queryResult;
};
